import $ from 'jquery';
import { Tab } from 'bootstrap';

$(() => {
  // switch to tab on page load
  if (window.location.hash !== '') {
    const hash = document.location.hash;
    const tabLink = $(`.nav-tabs a[href='${hash}']`);
    if (tabLink.length) {
      new Tab(tabLink[0]).show();
    }
  }

  // replace current history entry with selected tab
  $('.nav-tabs a').on('click', (e) => {
    if ('hash' in e.currentTarget && typeof e.currentTarget.hash === 'string' && e.currentTarget.hash.startsWith('#')) {
      history.replaceState({}, '', e.currentTarget.hash);
    }
  });
});
